import React, { useEffect, useState }  from 'react'
import { StyleSheet, View } from 'react-native'
import HeaderIconButton from '../../components/HeaderIconButton'
import ProductList from '../../components/ProductList'
import { useAtomValue } from 'jotai'
import { allProductsByCategoryListAtom, userRoleAtom } from '../../global/AtomsProvider'
import { useTranslation } from 'react-i18next'
export default function ProductsScreen( { navigation } ) {
  const productsByCategoryList = useAtomValue(allProductsByCategoryListAtom)
  const userRole = useAtomValue(userRoleAtom)
  const { t } = useTranslation()
  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <HeaderIconButton
          onPress={() => {
            navigation.navigate('ProductDetail', { productItemProp: null })
          }}
          iconName='plus-outline'
          testID='products-add-btn'
        />
      ),
    })
    if (navigation.getState()?.index === 0) {
      navigation.setOptions({
        headerLeft: () => (
          <HeaderIconButton
            onPress={() => {
              navigation.navigate('Home')
            }}
            iconName='arrow-back-outline'
          />
        ),
      })
    }
  }, [])

  return (
    <View style={styles.container}>
      <ProductList 
        showStoreFilter={true} 
        showAdditionallyInactiveProducts={userRole?.permissions?.['viewInactiveProducts'] || userRole?.id === 'admin' || userRole?.permissions?.['viewOtherStores']} 
        products={productsByCategoryList} 
        onItemPress={(item, index, store) => {navigation.navigate('ProductDetail', { productItemProp: item, store: store })}}
        links={[
          {
            text: t('productsAndIngredients.batchEdit'),
            action: () => {navigation.navigate('BatchProductEdit')},
            testID: 'products-batch-edit-link',
          },
          {
            text: t('productsAndIngredients.exportImport'),
            action: () => {navigation.navigate('ExportImport')},
            testID: 'products-export-import-link',
          },
        ]}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'stretch',
  }, 
});